export const GET_DEALER_API_REQUEST = "GET_DEALER_API_REQUEST";
export const GET_DEALER_API_SUCCESS = "GET_DEALER_API_SUCCESS";
export const GET_DEALER_API_ERROR = "GET_DEALER_API_ERROR";

export const DEALERS_LOAD_MORE = "DEALERS_LOAD_MORE"

export const EDIT_DEALER_SEARCH_QUERY = "EDIT_DEALER_SEARCH_QUERY"

export const EDIT_SELECTED_DEALER = "EDIT_SELECTED_DEALER"

export const GET_DEALER_BY_ID_API_REQUEST = "GET_DEALER_BY_ID_API_REQUEST";
export const GET_DEALER_BY_ID_API_SUCCESS = "GET_DEALER_BY_ID_API_SUCCESS";
export const GET_DEALER_BY_ID_API_ERROR = "GET_DEALER_BY_ID_API_ERROR";

export const UPDATE_SELECTED_DEALER= "UPDATE_SELECTED_DEALER"
export const UPDATE_SELECTED_DEALER_LMPACKAGE= "UPDATE_SELECTED_DEALER_LMPACKAGE"
export const UPDATE_SELECTED_DEALER_SUCCESS= "UPDATE_SELECTED_DEALER_SUCCESS"
